import React from 'react';
import Card from '../common/Card';
import Badge from '../common/Badge';
import { motion } from 'framer-motion';

const SuppliersView = ({ suppliers }) => {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6">
      <div className="flex justify-between items-end mb-6">
        <div>
          <h2 className="text-2xl font-bold text-white tracking-tight">Suppliers</h2>
          <p className="text-gray-400 mt-1">Vendor metrics and reliability tracking.</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {suppliers.map((supplier) => (
          <Card key={supplier.id} className="hover:border-sp-gray-600 transition-colors">
            <div className="flex justify-between items-start mb-4">
              <div>
                <h3 className="text-lg font-bold text-white">{supplier.name}</h3>
                <div className="text-xs text-gray-500 font-mono mt-1">{supplier.id}</div>
              </div>
              <Badge variant={supplier.reliability > 90 ? 'lime' : 'default'}>
                {supplier.reliability}% Reliability
              </Badge>
            </div>
            
            <div className="grid grid-cols-2 gap-4 mt-4">
              <div className="bg-sp-gray-800/50 p-3 rounded">
                <div className="text-[10px] text-gray-500 font-mono uppercase mb-1">Avg Lead Time</div>
                <div className="text-xl font-mono text-gray-200">{supplier.leadTime} <span className="text-xs text-gray-500">days</span></div>
              </div>
              <div className="bg-sp-gray-800/50 p-3 rounded">
                <div className="text-[10px] text-gray-500 font-mono uppercase mb-1">Active Orders</div>
                <div className="text-xl font-mono text-gray-200">{supplier.activeOrders}</div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </motion.div>
  );
};

export default SuppliersView;